import React, { useState, useEffect } from "react";
import Navber from "../Components/Navber.jsx";
import ResortSidebar from "../Components/ResortSidebar.jsx";
import ResortList from "../Components/ResortList.jsx";
import "../Styles/Hotel_page.css";
import api from "../Api.js";
import HotelDrawer from "../Components/HotelDrawer.jsx";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { Autocomplete, TextField, Button, CircularProgress, Box } from "@mui/material";

function Hotel_page() {
  const [hotelData, setHotelData] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [destinations, setDestinations] = useState([]);
  const [destination, setDestination] = useState(null);
  const [dateRange, setDateRange] = useState({ checkIn: null, checkOut: null });
  const [filters, setFilters] = useState({
    priceRange: null,
    propertyTypes: [],
    houseRules: [],
    roomViews: [],
  });

  // ✅ Load all hotels initially
  useEffect(() => {
    const fetchHotels = async () => {
      try {
        const res = await api.get("/hotels");
        if (res.data.status === true) {
          console.log("Fetched hotels:", res.data.data);
          setHotelData(res.data.data || []);
          setFilteredItems(res.data.data || []);
        }
      } catch (err) {
        console.error("Error fetching hotels:", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchHotels();
  }, []);

  // ✅ Load all destinations for Autocomplete
  useEffect(() => {
    const fetchDestinations = async () => {
      try {
        const res = await api.get("/destinations");
        console.log("the responsed destinations are : ", res.data);
        if (res.data.status === true) {
          const mapped = res.data.data.map((d) => ({
            id: d.id,
            label: d.name,
            cover_photo: d.cover_photo,
          }));
          setDestinations(mapped);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchDestinations();
  }, []);


  // ✅ Handle date changes
  const handleDateChange = (newValue, field) => {
    setDateRange((prev) => ({ ...prev, [field]: newValue }));
  };

  // ✅ Handle Search button click
  const handleSearch = async () => {
    if (!destination || !destination.id || !dateRange.checkIn || !dateRange.checkOut) {
      alert("Please select destination and both dates!");
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        destination_id: destination.id,
        check_in: dateRange.checkIn.toISOString().slice(0, 19).replace("T", " "),
        check_out: dateRange.checkOut.toISOString().slice(0, 19).replace("T", " "),
      };

      console.log("🔍 Searching hotels with:", payload);

      const res = await api.post("/availability/all", payload,{
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      console.log("🔍 Search response:", res.data);

      if (res.data.status === true) {
        setHotelData(res.data.data || []);


        setFilteredItems(res.data.data);
        console.log("✅ Parsed hotel results:", res.data.data);
      } else {
        setFilteredItems([]);
      }
    } catch (err) {
      console.error("Error searching hotels:", err);
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>

      {/* 🔍 Search Bar */}
<LocalizationProvider dateAdapter={AdapterDateFns}>
  <Box
    className="hotel-searchbar-container hotel-animate-slideIn"
    sx={{
      position: "sticky",        // ✅ Make it sticky
      top: 0,                    // ✅ Stick to top
      zIndex: 2,              // ✅ Ensure it stays above other elements
      display: "flex",
      flexWrap: "wrap",
      gap: 2,
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#fff",
      borderRadius: 2,
      boxShadow: 3,
      padding: 2,
      marginTop: 2,
    }}
  >
    {/* ✅ Destination Dropdown */}
    <Autocomplete
      options={destinations}
      getOptionLabel={(option) => option.label || ""}
      value={destination}
      onChange={(event, newValue) => setDestination(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Destination / Property"
          variant="outlined"
          size="small"
          sx={{
            minWidth: 220,
            "& .MuiInputBase-input": { padding: "10px 8px" },
          }}
        />
      )}
    />

    {/* ✅ Check-in / Check-out DateTimePickers */}
    <Box sx={{ display: "flex", gap: 2,flexWrap:"wrap",justifyContent:"center"}}>
      <DateTimePicker
        label="Check-in"
        value={dateRange.checkIn}
        onChange={(newValue) => handleDateChange(newValue, "checkIn")}
        minDateTime={new Date()}
        slotProps={{
          textField: {
            size: "small",
            sx: { minWidth: 200 },
          },
        }}
      />

      <DateTimePicker
        label="Check-out"
        value={dateRange.checkOut}
        onChange={(newValue) => handleDateChange(newValue, "checkOut")}
        minDateTime={dateRange.checkIn || new Date()}
        slotProps={{
          textField: {
            size: "small",
            sx: { minWidth: 200 },
          },
        }}
      />
    </Box>

    {/* ✅ Search Button */}
    <Button
      variant="contained"
      sx={{
        backgroundColor: "#F17228",
        color: "#fff",
        fontWeight: 600,
        padding: "10px 25px",
        borderRadius: "8px",
        "&:hover": { backgroundColor: "#ff9100" },
      }}
      onClick={handleSearch}
    >
      SEARCH
    </Button>
  </Box>
</LocalizationProvider>


      {/* 🏨 Main Hotel Listing Section */}
      <div className="resort-app-container">
        <aside className="resort-sidebar">
          <ResortSidebar filters={filters} setFilters={setFilters} />
        </aside>

        <HotelDrawer filters={filters} setFilters={setFilters} />

        <main className="resort-main-content">
          <div className="tourCardsWrapper">
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  minHeight: "30vh",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <div className="tourCardsGrid1">
                <ResortList filters={filters} hotelData={filteredItems} />
              </div>
            )}
          </div>
        </main>
      </div>
    </>
  );
}

export default Hotel_page;
